import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import CustomTextInput from '../../../components/CustomTextInput';
import { ProvisionTINValidation } from '../../../validations/ProvisionTINValidation';

const ProvisionTINModal = ({ open, organization, onClose, onSubmit, isLoading = false }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(ProvisionTINValidation()),
    defaultValues: { business_name: '', tin: '', email: '', vat_number: '' },
  });

  React.useEffect(() => {
    if (open) {
      reset({
        business_name: organization?.name ?? '',
        tin: '',
        email: organization?.email ?? '',
        vat_number: '',
      });
    }
  }, [open, organization?.email, organization?.name, reset]);

  const handleFormSubmit = (data) => {
    const tin = data.tin?.trim();
    const email = data.email?.trim();
    const business_name = data.business_name?.trim();
    const vat_number = data.vat_number?.trim();

    onSubmit({
      orgId: organization?.id,
      tin,
      email,
      business_name,
      vat_number,
    });
  };

  if (!organization) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Provision TIN</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Register a test TIN on SMP for this organization. The client must use the profile email and TIN to claim their
          business profile in the portal.
        </Typography>

        <Box component="form" onSubmit={handleSubmit(handleFormSubmit)}>
          <Grid container spacing={2}>
            <Grid size={12}>
              <CustomTextInput
                name="business_name"
                control={control}
                errors={errors}
                label="Business name"
                placeholderText="Zenith Logistics LLC"
              />
            </Grid>
            <Grid size={12}>
              <CustomTextInput
                name="email"
                control={control}
                errors={errors}
                label="Profile email"
                placeholderText="user@example.com"
              />
            </Grid>
            <Grid size={12}>
              <CustomTextInput
                name="tin"
                control={control}
                errors={errors}
                label="Test TIN"
                placeholderText="1415002641"
              />
            </Grid>
            <Grid size={12}>
              <CustomTextInput
                name="vat_number"
                control={control}
                errors={errors}
                label="VAT number"
                placeholderText="141500264100003"
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSubmit(handleFormSubmit)} disabled={isLoading}>
          {isLoading ? 'Provisioning…' : 'Provision TIN'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProvisionTINModal;
